import { useQuery } from "@tanstack/react-query";
import { getConfig } from "@/lib/api";
import { FACTORY_ADDRESS as ENV_FACTORY } from "@/config/contracts";

/// Returns the live launchpad config. The on-chain factory address is read at
/// runtime (from the backend) so it activates right after deployment without a rebuild.
export function useConfig() {
  const { data } = useQuery({ queryKey: ["config"], queryFn: getConfig, staleTime: 15_000 });
  const factory = data?.factory_address || ENV_FACTORY || "";
  return {
    factory,
    hook: data?.hook_address || "",
    chainId: data?.chain_id || 8453,
    ipfsEnabled: data?.ipfs_enabled ?? false,
    isDeployed: Boolean(factory),
  };
}
